<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">new sale order</small>
      </legend>
      <div>
        <form @submit.prevent="newSale()">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>
                  Sales date
                  <span class="text-danger">*</span>
                </label>
                <input type="date" class="form-control sales_date input-rounded f-s-14" required />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive" width="100">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Product</th>
                      <th scope="col">Truck</th>
                      <th scope="col">Unit</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Unit price</th>
                      <th scope="col">Total</th>
                      <th scope="col">Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sale_product, k) in saleItemsrows" :key="k">
                      <td scope="row">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteRow(k, sale_product)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, sale_product)"></i> -->
                      </td>
                      <td>
                        <model-list-select
                         
                          :list="systemProducts"
                          v-model="sale_product.product_id"
                          option-value="id"
                          option-text="product_name"
                          placeholder="select Product"
                        ></model-list-select>
                      </td>
                      <td>
                         <model-list-select
                         
                          :list="systemTrucks"
                          v-model="sale_product.truck_id"
                          option-value="id"
                          option-text="truck_no"
                          placeholder="select truck name"
                        ></model-list-select>
                      </td>
                      <td>
                        <select
                          name="product_measurement"
                          class="form-control input_rounded product_measurement"
                          v-model="sale_product.product_measurement"
                          required
                        >
                          <option value>Select Measurement</option>
                          <option value="KG">KILOGRAMS</option>
                          <option value="PCS">PIECES</option>
                          <option value="LTS">LITRES</option>
                          <option value="SET">SET</option>
                          <option value="PAIR">PAIR</option>
                          <option value="MTR">METRES</option>
                        </select>
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="sale_product.qty"
                          @change="calculateLineTotal(sale_product)"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="sale_product.unit_price"
                          @change="calculateLineTotal(sale_product)"
                        />
                      </td>
                      <td>
                        <input
                          readonly
                          class="form-control text-right"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="sale_product.total_price"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control text-right"
                          type="text"
                          v-model="sale_product.remark"
                        />
                      </td>
                    </tr>
                    <tr v-show="saleItemsrows.length === 0">
                      <td colspan="6">
                        <p class="text-center alert-danger p-2">No products added/available.</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="6" class="text-right">Sub Total</td>
                      <input
                        readonly
                        class="form-control text-right sub_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_subtotal"
                      />
                    </tr>
                    <tr>
                      <td colspan="6" class="text-right">Total</td>
                      <input
                        readonly
                        class="form-control text-right sales_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_total"
                      />
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 mb-2">
              <button type="button" class="btn btn-info" @click="addSaleItems">
                <i class="fa fa-plus-circle"></i>
                Add
              </button>
            </div>
            <button type="submit" class="btn btn-primary btn-flat creatingSale btn-rounded">
              <i class="fa fa-plus"></i> create sale order
            </button>
            <button type="button" class="btn-rounded btn-flat creatingSaleLoader btn-rounded">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
            </button>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import router from "../router/index";
import { ModelListSelect } from 'vue-search-select'
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0
    };
  },
  created() {
    this.loadProduct();
    this.loadTrucks();
    this.getProduct();
  },
  computed: {
    ...mapGetters([
      "saleItemsrows",
      "systemTrucks",
      "systemProducts",
      "getsystemProducts"
    ])
  },
  methods: {
    ...mapActions(["newSale", "loadTrucks", "loadProduct", "getProduct"]),
    ...mapMutations(["addSaleItems"]),

    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.saleItemsrows.reduce(function(sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(sale_product) {
      var total =
        parseFloat(sale_product.unit_price) * parseFloat(sale_product.qty);
      if (!isNaN(total)) {
        sale_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, sale_product) {
      var idx = this.saleItemsrows.indexOf(sale_product);
      console.log(idx, index);
      if (idx > -1) {
        this.saleItemsrows.splice(idx, 1);
      }
      this.calculateTotal();
    }
  },
   components: {
      ModelListSelect
    }
};
</script>
<style scoped>
.creatingSaleLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/sales/sale.vue